import { AxiosResponse } from 'axios';
import { SignalApiUrls } from '../../../urls';
import { Maybe } from '../../../types';
import { HttpClient } from '../../../HttpClient';

export default class IntrospectClient extends HttpClient {
  async fetchIntrospect(): Promise<AxiosResponse<Maybe<any>>> {
    const response = await this.get<AxiosResponse<Maybe<any>>>(
      SignalApiUrls.getPartnersUrl(),
    );
    return response;
  }
}
